import valorParaReal from './valor-para-real'

export default {
    install(Vue) {
        Vue.filter('valorParaReal', valorParaReal)
    }

}

export {
    valorParaReal,
}
